import { createFileRoute } from '@tanstack/react-router';

import { SyncDataTypesPage } from '@pages/sync';

/**
 * Sync - Data Types
 *
 * Route: /:locale/sync/data-types
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/data-types')({
  component: SyncDataTypesRoute,
});

function SyncDataTypesRoute() {
  return <SyncDataTypesPage />;
}
